export default "__VITE_ASSET__37caa0d5__"